module.exports = __webpack_public_path__ + "img/companyIntro11.6272e28b.png";